import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';


export default function NotFound() {

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="min-h-screen bg-gradient-to-br from-[#F8FAFA] to-white flex flex-col items-center justify-center px-6 py-20"
    >
      {/* 404 Heading */}
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-2xl"
      >
        <h1 className="text-[8rem] font-extrabold text-[#FF5841] leading-none mb-2">404</h1>
        <p className="text-5xl font-bold text-gray-900 mb-8 mt-4">Page not found</p>
        <p className="text-gray-600 mb-10">
          Sorry, the page you are looking for could not be found. It may have been moved, renamed, or no longer exists.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-14">
          <Link
            to="/step/1"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg border-2 border-[#FF5841] text-[#FF5841] bg-white hover:bg-[#FFF3F1] transition-colors duration-200 font-medium"
          >
            Back to Form
          </Link>

          <a
            href="https://www.primehost.co.za/"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#FF5841] text-white hover:bg-[#E5503A] transition-colors duration-200 font-medium"
          >
            Go to Homepage
          </a>
        </div>

    
      </motion.div>
    </motion.div>
  );
}